export const ActionTypes = {
    HEADER_LENGTH : 'HEADER_LENTH',
    INITIALIZE : 'INITIALIZE',
    LOGIN : 'LOGIN',
    LOGOUT : 'LOGOUT',
    CREATE_DEBATE : 'CREATE_DEBATE',
    DEBATES_LIST : 'DEBATES_LIST',
    AVATAR: 'AVATAR',
    CHANGE_GENDER:'CHANGE_GENDER',
    JOINING_DEBATE:'JOINING_DEBATE',
    DEBATE_DETAILS:'DEBATE_DETAILS',
    FREESTYLE_DETAILS:'FREESTYLE_DETAILS',
    INTERMEDIATE_DETAILS:'INTERMEDIATE_DETAILS',
    ADVANCE_DETAILS:'ADVANCE_DETAILS',
    TOPICS:'TOPICS',
    TIMER:'TIMER',
    ROOMID:'ROOMID',
    ALLMEMBER:'ALLMEMBER',
    VOTING:'VOTING',
    CREATE_VOTING:'CREATE_VOTING',
    COUNTER_STATEMENT:'COUNTER_STATEMENT',
    REMOVE_MEMBER:'REMOVE_MEMBER',
    FINISH_DEBATE:"FINISH_DEBATE",
    SUBSCRIPTION_CHECK:"SUBSCRIPTION_CHECK",
    USERSUBSCRIPTION:"USERSUBSCRIPTION",
    REMAINING_DEBATES:"REMAINING_DEBATES",

};